import { configEnv } from '@/shared/config-env';
import {
  CancelOrderPayload,
  MakeOrderPayload,
  OrderApiResponse,
  OrdersApiResponse,
} from '@/shared/interfaces';
import { useUserStore } from '@/shared/store/useUserStore';
import axios from 'axios';
import handleApiError from '../handleApiError';

const API_URL: string = configEnv.VUE_APP_LOYALTY_API_URL;

/**
 * @description Получить список заказов.
 */
export async function getOrders(filters: any = {}) {
  try {
    const userStore = useUserStore();
    const { userEmail } = userStore.getUserInfo;

    const { data } = await axios.get<OrdersApiResponse>(`${API_URL}/v2/api/orders?include=productImage`, {
      params: filters,
    });
    const { orders } = data.response;
    return orders;
  } catch (error) {
    handleApiError(error);
  }
}

/**
 * @description Получить детали заказа.
 * @param {number} orderId - Номер заказа.
 */
export async function getOrderById(orderId: number) {
  try {
    const { data } = await axios.get(`${API_URL}/api/orders/${orderId}?include=statusDetail`);
    if (data.response.order) {
      return data.response.order;
    }
  } catch (error) {
    handleApiError(error);
  }
}

/**
 * @description Отправить сообщение от клиента для отмены заказа.
 * @param {Object} payload
 * @param {number} payload.orderId - Номер заказа.
 * @param {string} payload.message - Сообщение от клиента.
 */

export async function sendMessage(payload: CancelOrderPayload) {
  try {
    const { orderId, message } = payload;
    await axios.post(`${API_URL}/api/orders/${orderId}/message`, {
      source: 'Форма отмены заказа',
      message,
    });
  } catch (error) {
    handleApiError(error);
  }
}

/**
 * @description Создать заказ.
 * @param {Object} payload
 * @param {number} payload.cardId - ID физической карты пользователя.
 * @param {string} payload.comment - Комментарий пользователя при создании заказа.
 * @param {string} payload.date - Дата и время создания заказа в формате ISO.
 * @param {string} payload.description - Описание заказа.
 * @param {number} payload.prodId - ID товара.
 */
export async function makeOrder(payload: MakeOrderPayload) {
  try {
    if (configEnv.VUE_APP_ENVIRONMENT === 'development') {
      payload.skipSend2SD = 1;
    }
    const { data } = await axios.post<OrderApiResponse>(`${API_URL}/api/orders`, payload);
    if (data.response?.order) {
      return data.response.order;
    }
  } catch (error) {
    handleApiError(error);
  }
}
